import { defineComponent } from 'vue';
import { mapState, useStore } from 'vuex';
import copy from 'clipboard-copy';
import { openInIframe } from '@remote/utils';
import { isAndroidNative as isAndroid, sendMessage, isIOSNative as isIOS } from '@xunlei/universal-native-api';
export default defineComponent({
  name: 'Footer',
  setup() {
    return {
      store: useStore()
    };
  },
  computed: {
    ...mapState(['all', 'selects', 'action', 'deleteCompletely', 'taskType']),
    num() {
      return this.selects.length;
    },
    currentId() {
      return this.selects[0];
    },
    curFile() {
      return this.all[this.currentId];
    },
    copyList() {
      return this.selects.map(id => this.all[id]).filter(v => v.type === 'user#download-url').map(v => v.params.url);
    },
    checkIsIos() {
      return !!isIOS;
    },
    /**
     * 是否选中的所有任务的文件都已被删除
     */
    isAllSelectedTaskDeleted() {
      return this.selects.every(i => {
        var _this$all$i;
        return ((_this$all$i = this.all[i]) === null || _this$all$i === void 0 || (_this$all$i = _this$all$i.params) === null || _this$all$i === void 0 ? void 0 : _this$all$i.is_deleted) === 'true';
      });
    }
  },
  watch: {
    action(val) {
      if (val === 'delete') this.handleDelDo();
    }
  },
  methods: {
    cancelSel() {
      this.store.commit('update', {
        isSelect: false,
        selects: []
      });
    },
    handleCopy() {
      console.log(this.copyList, this.copyList.join('\n'));
      copy(this.copyList.join('\n'));
      this.cancelSel();
    },
    handleDel() {
      this.store.commit('update', {
        deleteCompletely: false
      });
      const tip = this.isAllSelectedTaskDeleted ? '' : '同时删除设备文件';
      this.store.commit('dialog', {
        show: true,
        title: '确定要删除该任务吗？',
        tip,
        okTxt: '确定',
        cancelTxt: '取消',
        hasCheck: !this.isAllSelectedTaskDeleted,
        action: 'delete'
      });
    },
    async handleDelDo() {
      this.store.commit('dialog', {
        show: false
      });
      this.store.commit('update', {
        isSelect: false,
        action: '',
        deleteTaskList: this.selects
      });
      for (let i = 0; i < this.selects.length; i++) {
        var _task$name;
        const id = this.selects[i];
        const task = this.all[id];
        const isEmptyName = ['', undefined, null].includes(task === null || task === void 0 || (_task$name = task.name) === null || _task$name === void 0 ? void 0 : _task$name.trim());
        if (this.deleteCompletely && !isEmptyName) {
          await this.store.dispatch('actionTask', {
            id,
            action: 'delete',
            willRefresh: i === this.selects.length - 1,
            willCheck: true
          });
        } else {
          await this.store.dispatch('delete', id);
        }
      }
      if (!this.deleteCompletely) {
        const delStat = this.taskType === 'ing' ? 'downloading_delete_btn_click' : 'complete_delete_btn_click';
        const selectedTasks = this.selects.map(id => {
          const task = this.store.state.all[id];
          if (task) {
            var _task$params;
            return task === null || task === void 0 || (_task$params = task.params) === null || _task$params === void 0 ? void 0 : _task$params.hash;
          }
          return '';
        }).filter(Boolean);
        this.$stat({
          action: delStat,
          data: {
            if_delete_file: 0,
            gcid: selectedTasks.map(task => {
              var _task$params$hash;
              return (_task$params$hash = task.params.hash) !== null && _task$params$hash !== void 0 ? _task$params$hash : '';
            }),
            info_hash: selectedTasks.map(task => {
              var _task$params$info_has;
              return (_task$params$info_has = task.params.info_hash) !== null && _task$params$info_has !== void 0 ? _task$params$info_has : '';
            }),
            url: selectedTasks.map(task => {
              var _task$params$url;
              return (_task$params$url = task.params.url) !== null && _task$params$url !== void 0 ? _task$params$url : '';
            })
          }
        });
      }
      this.cancelSel();
    },
    handleReport() {
      const id = this.curFile.params.file_id || this.curFile.id;
      const gcid = this.curFile.params.guid || '';
      const name = this.curFile.file_name || this.curFile.name;
      const url = `https://sj-m-ssl.xunlei.com/h5/report?file_id=${id}&gcid=${gcid}&file_name=${encodeURIComponent(name)}`;
      console.log(this.curFile);
      console.log(url);
      // this.cancelSel()
      if (isAndroid) {
        sendMessage({
          platform: 'android',
          name: 'xlOpenUrl',
          params: {
            url,
            title: '',
            openType: 1,
            from: 'remote_control_h5'
          }
        }, {
          noCallback: true
        });
      } else if (isIOS) {
        sendMessage({
          platform: 'ios',
          name: 'xunleiQuery',
          params: {
            target: 'hybrid',
            action: 'openHybridWeb',
            params: {
              url,
              title: '',
              from: 'remote_control_h5'
            }
          }
        }, {
          noCallback: true
        });
      } else {
        // window.open(url, '_blank')
        openInIframe({
          url,
          title: '举报',
          showClose: false
        });
      }
    }
  }
});